export const supportedLocales = ['pl', 'cs', 'sk', 'ro', 'hu', 'bg', 'uk'] as const;

export type SupportedLocale = (typeof supportedLocales)[number];
